import { styled } from '@mui/material';

export const Wrapper = styled('div')({
  background: '#f9fafb',
  padding: '0.75rem 1.1rem',
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  borderBottom: '1px solid #eef0f4',
});

export const Title = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
});

export const Logo = styled('img')({
  width: '30px',
  height: '25px',
});

export const ButtonsWrapper = styled('div')({
  marginLeft: 'auto',
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
});

export const HeaderButton = styled('button')(({ disabled, theme }) => ({
  background: '#eef1f6',
  color: disabled ? theme.palette.text.disabled : theme?.palette.text.primary,
  border: 0,
  padding: '0.35rem 0.55rem',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background 0.15s ease',
  '&:hover': {
    background: disabled ? '#eef1f6' : '#d1d9e6',
  },
}));
